var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3131_17395",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3131_17395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.33852 14.3078C5.14206 14.3078 4.12767 13.8911 3.29535 13.0578C2.46303 12.2244 2.04688 11.2017 2.04688 9.98965C2.04688 8.77758 2.48785 7.75836 3.36979 6.93197C4.25172 6.10558 5.29525 5.69238 6.50037 5.69238H14.861C15.7241 5.69238 16.4575 5.99424 17.0612 6.59794C17.6649 7.20164 17.9667 7.93504 17.9667 8.79815C17.9667 9.68904 17.644 10.4294 16.9987 11.0192C16.3533 11.609 15.5921 11.9039 14.7151 11.9039H6.9035C6.37018 11.9039 5.9194 11.7198 5.55117 11.3517C5.18292 10.9836 4.99879 10.533 4.99879 9.99984C4.99879 9.44337 5.19783 8.98698 5.5959 8.63067C5.99398 8.27438 6.45733 8.09624 6.98596 8.09624H15.111V9.3398H6.90263C6.71556 9.3398 6.55874 9.40279 6.43219 9.52878C6.30563 9.65478 6.24235 9.8109 6.24235 9.99715C6.24235 10.1834 6.30563 10.3405 6.43219 10.4684C6.55874 10.5964 6.71556 10.6603 6.90263 10.6603H14.861C15.3824 10.6603 15.8231 10.4807 16.1831 10.1213C16.5432 9.76194 16.7232 9.32204 16.7232 8.80159C16.7232 8.28113 16.5391 7.84008 16.171 7.47842C15.803 7.11679 15.3524 6.93597 14.8193 6.93597H6.35454C5.49985 6.93597 4.77897 7.23297 4.1919 7.82699C3.60481 8.421 3.30433 9.14404 3.29044 9.99609C3.27655 10.862 3.58611 11.5899 4.21913 12.1796C4.85214 12.7693 5.59333 13.0642 6.44269 13.0642H15.111V14.3078H6.33852Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.9b8899d420cba2c6fde72b89ea7627ce.svg";
export { ForwardRef as ReactComponent };